import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../../Modal';
import Spinner from '../../../Spinner';
import Form, { FormBody, FormActions, TextInput, ColorInput } from '../../../Form';

@inject('ticketActionStore')
@observer
class ActionEdit extends Component {
  // static propTypes = {
    // route: PropTypes.shape().isRequired,
    // params: PropTypes.shape({
      // id: PropTypes.string.isRequired,
    // }).isRequired,
    // unitStore: PropTypes.object.isRequired,
  // };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  slug = '/monitoring/config/action';
  title = 'Edit Ticket Action';
  disposer = null;
  @observable item = {
    caption : '',
    description: '',
    color: ''
  };

  constructor(props) {
    super(props);

    const { params: { id }, ticketActionStore } = props;

    ticketActionStore.fetchItem(id);
  }

  componentWillMount() {
    this.reset();
  }

  @action reset() {
    const { params: { id }, ticketActionStore } = this.props;
    const foundAction = ticketActionStore.findById(id);
    if (foundAction) {
      this.item = foundAction.asJson;
    }
  }

  @action onChangeCaption = e => this.item.caption = e.target.value;
  @action onChangeDescription = e => this.item.description = e.target.value;
  @action onChangeColor = e => this.item.color = e.target.value;

  handleSave = (e) => {
    e.preventDefault();

    const { ticketActionStore } = this.props;
    ticketActionStore.updateItem(this.item)
      .then(() => {
        this.context.router.push(this.slug);
      });
  }

  render() {
    const { ticketActionStore, params: { id } } = this.props;

    if (ticketActionStore.isLoading) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={this.slug} isSaving={ticketActionStore.isSaving}>
        <Form>
          <FormBody>
            <TextInput label={'Id'} value={id} readOnly />
            <TextInput label='Caption' value={this.item.caption} onChange={this.onChangeCaption}/>
            <TextInput label='Description' value={this.item.description} onChange={this.onChangeDescription}/>
            <ColorInput label='Color' value={this.item.color} onChange={this.onChangeColor}/>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default ActionEdit;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Configuration/Action/ActionEdit.js